import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import RoleViewModel from '../../../../core/features/authorization/viewmodels/RoleViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'Authorization-Roles',
            viewModel: null,
            modules: [],
            permissions: [],
            modulesWithPermissions: [],
            claims: [],
            activeCollapseNames: [],
            rules: {
                name: [
                    { required: true, message: 'Nombre requerido.', trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.viewModel = new RoleViewModel(this)
        this.onActive();
    },
    mounted() { },
    methods: {
        onActive() {
            this.viewModel.bindFormView(this.formData);
        },
        verifyRole(rule, value, callback) { 
            this.viewModel.verifyRoleName(this.formData.id, value, callback) 
        },
        getModulePermissions(parentModule) {
            if (!parentModule || !parentModule.subModules) return [];
            const result = [];
            parentModule.subModules.forEach(sub => {
                if (sub.permissions && Array.isArray(sub.permissions)) {
                    sub.permissions.forEach(p => {
                        if (p && p.code) {
                            result.push(p.code);
                        }
                    });
                }
            });
            return result;
        },
        getModuleSelectedCount(parentModule) {
            const modulePerms = this.getModulePermissions(parentModule);
            const claimsList = this.claims || [];
            return modulePerms.filter(code => claimsList.includes(code)).length;
        },
        getModuleTotalCount(parentModule) {
            return this.getModulePermissions(parentModule).length;
        },
        onSelectAllModulePermissions(parentModule) {
            const perms = this.getModulePermissions(parentModule);
            const currentClaimsSet = new Set(this.claims || []);
            perms.forEach(p => currentClaimsSet.add(p));
            this.claims = Array.from(currentClaimsSet);
        },
        onDeselectAllModulePermissions(parentModule) {
            const permsSet = new Set(this.getModulePermissions(parentModule));
            this.claims = (this.claims || []).filter(code => !permsSet.has(code));
        },
        onSelectAllPermissions() {
            if (!this.permissions || !Array.isArray(this.permissions)) return;
            const allCodes = [];
            this.permissions.forEach(parent => {
                if (parent?.code) {
                    allCodes.push(parent.code);
                }
                if (Array.isArray(parent?.subModules)) {
                    parent.subModules.forEach(sub => {
                        if (sub?.code) {
                            allCodes.push(sub.code);
                        }
                        if (Array.isArray(sub?.permissions)) {
                            sub.permissions.forEach(perm => {
                                if (perm?.code) {
                                    allCodes.push(perm.code);
                                }
                            });
                        }
                    });
                }
            });
            this.claims = Array.from(new Set(allCodes));
        },
        onDeselectAllPermissions() {
            this.claims = [];
        },
        onSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formData.claims = this.claims;
                    this.onSave(this.formData);
                }
            });
        },
        onCanSaveOrUpdate() {
            return this.canCreate(this.modulePermissions) || this.canUpdate(this.modulePermissions);
        },
        onCanCreate() {
            return this.canCreate(this.modulePermissions);
        },
        onCanUpdate() {
            return this.canUpdate(this.modulePermissions);
        },
        onSaveResponse(response) {
            this.showLoading(false, '');
            this.onShowSuccess(response.message);
            this.showComponent(false);
            EventBus.$emit('onSubmitedRole', null);
        }
    }
}